
/* ============================================================================
   LUPA (buscador global) + PERFIL (cuenta)
   · La lupa busca en todo el catálogo (window.VELANTIS_CAT) por nombre, casa,
     familia y notas; al elegir una fragancia abre su vista rápida.
   · La cuenta se conecta a los Customer Accounts de Shopify: cuando se defina
     window.SHOP.domain, los botones llevan a las páginas seguras de Shopify
     (/account/login, /account/register, /account). Velantis nunca maneja las
     contraseñas: de eso se encarga Shopify.
   ============================================================================ */
(function(){
  var CAT=window.VELANTIS_CAT||[];
  function de(s){return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  var SINONIMOS = {
    'ambiental':  'ambientales aromatizante aromatizantes ambientador ambientadores ' +
                  'aroma de ambiente spray para casa home scent hogar casa habitacion',
    'aceite':     'aceites recarga refill esencia esencias difusor',
    'difusor':    'difusores nebulizador aromatizador electrico',
    'dama':       'mujer mujeres femenino ella para ella',
    'caballero':  'hombre hombres masculino el para el',
    'unisex':     'ambos compartido sin genero'
  };
  function extras(r){
    var cat = de(r[1] || '');
    var sub = de(String(r[3] || '') + ' ' + String(r[9] || ''));
    var s = SINONIMOS[cat] || '';
    if(/aceite/.test(sub)) s += ' ' + SINONIMOS['aceite'];
    if(/difusor/.test(sub)) s += ' ' + SINONIMOS['difusor'];
    return cat + ' ' + s;
  }
  /* La CATEGORIA entra al indice: sin ella «ambiental» no encontraba
     los 38 productos de su propia coleccion. Ver fusionar.py, paso 3. */
  var HAY=CAT.map(function(r){return de(r[0]+' '+r[2]+' '+r[3]+' '+r[5]+' '+r[6]+' '+r[7]+' '+(r[8]||'')+' '+(r[12]||'')+' '+extras(r));});

  /* ---------- Lupa ---------- */
  var gsOv=document.getElementById('gsOv'), gsInput=document.getElementById('gsInput'),
      gsRes=document.getElementById('gsResults'), gsMeta=document.getElementById('gsMeta');

  function gsRender(){
    var q=de(gsInput.value.trim());
    if(!q){ gsMeta.textContent=''; gsRes.innerHTML='<p class="gs-hint">Escribe para buscar entre '+CAT.length+' fragancias.</p>'; return; }
    var out=[];
    for(var i=0;i<CAT.length && out.length<200;i++){ /* 4-sep: antes 30; el contador decia 46 y la lista ensenaba 30 */ if(HAY[i].indexOf(q)>=0) out.push(CAT[i]); }
    var tot=0; for(var j=0;j<CAT.length;j++){ if(HAY[j].indexOf(q)>=0) tot++; }
    gsMeta.textContent = tot? tot+' resultado'+(tot>1?'s':'') : '';
    gsRes.innerHTML = out.length ? out.map(function(r){
      return '<button class="gs-item" data-name="'+esc(r[0])+'">'+
        '<span class="gs-thumb n-'+r[9]+'"></span>'+
        '<span><span class="gs-name">'+esc(r[0])+'</span>'+
        '<span class="gs-sub">'+esc(r[3])+' · '+esc(r[1])+(r[2]?' · '+esc(r[2]):'')+'</span></span></button>';
    }).join('') : '<p class="gs-empty">No encontramos fragancias para “'+esc(gsInput.value)+'”.</p>';
  }
  function gsOpen(){ gsOv.classList.add('show'); document.body.style.overflow='hidden'; setTimeout(function(){gsInput.focus();},60); }
  function gsClose(){ gsOv.classList.remove('show'); document.body.style.overflow=''; }
  gsInput.addEventListener('input',gsRender);
  gsRes.addEventListener('click',function(e){
    var b=e.target.closest('.gs-item'); if(!b) return;
    gsClose();
    if(window.VelantisCatalogo) window.VelantisCatalogo.openByName(b.dataset.name);
  });
  document.getElementById('gsClose').addEventListener('click',gsClose);
  gsOv.addEventListener('click',function(e){ if(e.target===gsOv) gsClose(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ gsClose(); acClose(); } });

  var lupa=document.querySelector('.tools .icon-btn[aria-label="Buscar"]');
  if(lupa) lupa.addEventListener('click',function(){ gsRender(); gsOpen(); });

  /* ---------- Cuenta ---------- */
  var acOv=document.getElementById('acOv'), acNote=document.getElementById('acNote');
  function shopUrl(path){ return (window.SHOP && SHOP.domain) ? 'https://'+SHOP.domain+path : null; }
  function goShop(path){
    var u=shopUrl(path);
    if(u){ window.location.href=u; }
    else { acNote.textContent='Las cuentas se activan al conectar la tienda de Shopify (Customer Accounts). Mientras tanto, escríbenos a ventas@velantis.mx y con gusto te ayudamos.'; }
  }
  function acOpen(){ acOv.classList.add('show'); document.body.style.overflow='hidden';
    acNote.textContent = shopUrl('') ? '' : 'Conecta tu tienda de Shopify para activar el inicio de sesión seguro.'; }
  function acClose(){ acOv.classList.remove('show'); document.body.style.overflow=''; }
  document.getElementById('acLogin').addEventListener('click',function(){ goShop('/account/login'); });
  document.getElementById('acRegister').addEventListener('click',function(){ goShop('/account/register'); });
  document.getElementById('acOrders').addEventListener('click',function(e){ e.preventDefault(); goShop('/account'); });
  document.getElementById('acClose').addEventListener('click',acClose);
  acOv.addEventListener('click',function(e){ if(e.target===acOv) acClose(); });

  var perfil=document.querySelector('.tools .icon-btn[aria-label="Mi perfil"]');
  if(perfil) perfil.addEventListener('click',acOpen);

  window.acClose=acClose;
})();
